import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  namespace: 'inquiry',
  mountedUrl: '/daily-rental/inquiries',
  titleNew: 'Create new inquiry',
  titleEdit: 'Edit inquiry',
  displayName: (object) => object.reference,
  checkIsValid: (props) => {
    const hasRelations = props.objectData.property && props.objectData.property.value[1] && props.objectData.customer && props.objectData.customer.value[1];
    return hasRelations && !!props.objectData.origin && !!props.objectData.creation_date && !!props.objectData.arrival_date && !!props.objectData.departure_date;
  },
  afterCreate: (props) => {
    const messageId = props.savedObject.original_message_id.value[1];
    props.api.routing.redirect(props.router, `/email/messages/${messageId}`);
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/containers/Form.jsx